<div class="main-div">
<div class="card-contianer">
<div class="container-fluid hero-section py-5">
  <div >
    <div class="row align-items-center">

      <!-- LEFT CONTENT -->
      <div class="col-lg-6 col-md-12 text-center text-lg-start">
        <h1 class="heading fw-bold mb-3">
          Marketing Email
        </h1>

        <p class="justify-text mb-4 hero-text">
          Kick-start your email journey with predominant email solutions that help you
          build email templates, email campaigns, automate, send and monitor your
          email marketing campaigns directly with real-time email solutions to trigger
          directly to the inboxes with top-notch deliverability.
        </p>

        <div class="d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
            <a routerLink="/signup" href="/signup" aria-label="Sign Up" class="btn btn-signup px-4 py-2 rounded-pill" [attr.href]="'/signup'">Sign Up</a>
<!-- 
          <button class="btn btn-light shadow rounded-circle play-btn">
            ▶
          </button> -->
        </div>
      </div>

      <!-- RIGHT IMAGE -->
      <div class="col-lg-6 col-md-12 text-center mt-4 mt-lg-0">
        <img
          src="assets\images\bulk-mailing\bulk-mailing1.png"
          alt="Marketing Email"
          class="img-fluid hero-img"
        />
      </div>

    </div>
  </div>
</div>

<!-- Why Marketing Emails? -->
<div class="why-market mb-4">
<div class="text-center py-2 why-section">

  <h2 class="heading fw-bold mb-3">
    Why Marketing Emails?
  </h2>

  <p class="text-muted why-text mx-auto">
    Make it easier for customers to connect with you by simplifying your approach and achieve your business objectives with email marketing campaigns. Enjoy potent, yet straightforward segmentation, versatile and frustration-free campaign editing, and actionable analytics, all powered by a leading email marketing service.
  </p>

</div>
</div>

<!-- Why customers choose us? -->
 
 <div class="why-container">
  <h2 class="heading title text-center mb-5">Why customers choose us?</h2>

  <div class="row g-4">

    <!-- Card 1 -->
    <div class="col-md-6">
      <mat-card class="feature-card">
        <div class="card-content d-flex">
          <div class="icon">
            <i class="bi bi-envelope-check-fill icon"></i>
          </div>
          <div>
            <h4>Deliverability</h4>
            <p class="para">
              Domain Authentication, Compliance, Deliverability coaching, and proactive ISP outreach to ensure optimal inbox delivery.
            </p>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- Card 2 -->
    <div class="col-md-6">
      <mat-card class="feature-card">
        <div class="card-content d-flex">
          <div class="icon">
            <i class="bi bi-graph-up-arrow icon"></i>
          </div>
          <div>
            <h4>Scale with Confidence</h4>
            <p class="para">
              Startup or Large enterprise, we handle important emails by delivering over 60 billion emails per month.
            </p>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- Card 3 -->
    <div class="col-md-6">
      <mat-card class="feature-card">
        <div class="card-content d-flex">
          <div class="icon">
            <i class="bi bi-headset icon"></i>
          </div>
          <div>
            <h4>Email Expertise</h4>
            <p class="para">
              Our Support Teams are just a click away who gives you guidance with our 24/7 multi-channel backing system.
            </p>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- Card 4 -->
    <div class="col-md-6">
      <mat-card class="feature-card">
        <div class="card-content d-flex">
          <div class="icon">
            <i class="bi bi-hand-index-thumb-fill icon"></i>
          </div>
          <div>
            <h4>Single Send</h4>
            <p class="para">
              One-time non-automated email message delivered to a list or segment of your customers.
            </p>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- Card 5 -->
    <!-- <div class="col-md-6">
      <mat-card class="feature-card">
        <div class="card-content d-flex">
          <div class="icon">
            <i class="icon">campaign</i>
          </div>
          <div>
            <h4>Marketing Automation</h4>
            <p class="para">
              Create personalized experiences, invite conversations in a way that’s scalable and relevant which helps you improve sender reputation and customer retention.
            </p>
          </div>
        </div>
      </mat-card>
    </div> -->

  </div>
</div>


<!-- tools-section -->
<div class="tools-section">
  <div class="text-center">

    <!-- Heading -->
    <h2 class="heading main-title mx-auto mb-4">
      Our instinctive tools help you create engaging, high-performing email campaigns.
    </h2>

    <!-- Cards -->
    <div class="row g-4 justify-content-center">

      <div class="col-md-6 col-lg-4" *ngFor="let item of tools">
        <div class="tool-card text-start"> 
          <i class="bi mb-3" [ngClass]="item.icon"></i>

          <h5 class="card-title mb-3">{{ item.title }}</h5>

          <p class="card-desc">
            {{ item.desc }}
          </p>

        </div>
      </div>

    </div>

  </div>
</div>


<!-- clients -->

<!-- <div class="clients-section text-center">
  <div >

    <h2 class=" heading clients-title mb-5">
      Customers who are using our Marketing Emails
    </h2>

    <div class="row align-items-center justify-content-center g-4">


      <div class="col-4 col-md-3 col-lg-2 d-flex justify-content-center">
        <div class="logo-box1">
          <img src="assets/images/customers/crompton-greaves-logo.webp"
               alt="Crompton"
               class="client-logo">
        </div>
      </div>


      <div class="col-4 col-md-3 col-lg-2 d-flex justify-content-center">
        <div class="logo-box3">
          <img src="assets/images/customers/logo-atqor.webp"
               alt="Atqor"
               class="client-logo">
        </div>
      </div>


      <div class="col-4 col-md-3 col-lg-2 d-flex justify-content-center">
        <div class="logo-box2">
          <img src="assets/images/customers/logo-exabytes.webp"
               alt="Exabytes"
               class="client-logo">
        </div>
      </div>



    </div>

  </div>
</div> -->




<div class="container py-5">
  <h2 class="text-center fw-bold mb-4 heading">FAQs</h2>

  <div class="row g-4 ">

    <!-- LEFT COLUMN -->
    <div class="col-lg-6">
      <div *ngFor="let faq of faqsLeft" class="faq-card mb-3">
        
        <div class="faq-header" (click)="toggle(faq)">
          <span>{{ faq.question }}</span>
          <i class="bi" [ngClass]="faq.open ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>

        <div class="para faq-body" *ngIf="faq.open">
          {{ faq.answer }}
        </div>

      </div>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="col-lg-6">
      <div *ngFor="let faq of faqsRight" class="faq-card mb-3">
        
        <div class="faq-header" (click)="toggle(faq)">
          <span>{{ faq.question }}</span>
          <i class="bi" [ngClass]="faq.open ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>

        <div class=" para faq-body" *ngIf="faq.open">
          {{ faq.answer }}
        </div>

      </div>
    </div>

  </div>
</div>



</div>
</div>